import React from 'react'

const OrderTab = ({ step, setStep }) => {
  return (
    <div className='btn !bg-[--bg-color-500] !text-white cursor-pointer' onClick={() => setStep(2)}>Go To Workflow Tab</div>
  )
}

export default OrderTab